export default __webpack_public_path__ + "static/media/88i-favicon.f827ff43.jpeg";